import * as events from 'events'

export abstract class MsgParser extends events.EventEmitter {
}
